<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/8.jpeg/8.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong
        >マイホーム購入者もマイナス金利解除に関心あり。借り換え検討は12.4%</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          既にマイホームを所有している方へ
          <strong
            >「2024年3月のマイナス金利政策解除が発表されたことにより、住宅ローンの借り換えは検討していますか」</strong
          >
          と質問したところ
          <strong>「検討している」方が12.4%となりました。</strong>
        </p>
        <p>
          検討している方の理由は、
          <strong>「（借り換えにより）金利が低くなる」</strong>
          ことを期待している方が最も多い（変動金利選択者25.7%、固定金利選択者32.9%）ことがわかり、借り換えによる金利の変動の可能性を探っている様子が伺えます。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
